import { Box, SectionTitle } from '@base-app';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AddTeamMemberForm from '../AddTeamMemberForm/AddTeamMemberForm';
import { SendStyled, SendErrorStyled, SendingStyled } from './AddTeamMemberCard.styles';
import loadingUrl from '@assets/icons/loading.gif';
import { AddTeamMemberCardProps } from './AddTeamMemberCard.types';

const AddTeamMemberCard: FC<AddTeamMemberCardProps> = ({
  showForm,
  showSendingMessage,
  showSuccessMessage,
  showErrorMessage,
  onAddTeamMember,
}) => {
  const { t } = useTranslation('teams');

  let image = null;
  let message = '';
  if (!showForm) {
    if (showSendingMessage) {
      image = <SendingStyled src={loadingUrl} alt="loading..." />;
      message = 'add_team_member_message_sending';
    } else if (showSuccessMessage) {
      image = <SendStyled />;
      message = 'add_team_member_message_success';
    } else if (showErrorMessage) {
      image = <SendErrorStyled />;
      message = 'add_team_member_message_error';
    }
  }

  return (
    <>
      {showForm && <AddTeamMemberForm onSaveForm={onAddTeamMember} />}
      {!showForm && (
        <Box css={{ textAlign: 'center' }}>
          {image}
          <SectionTitle css={{ fontWeight: '$bold' }} data-testid="add-team-member-card-title">
            {t(message)}
          </SectionTitle>
        </Box>
      )}
    </>
  );
};

export default AddTeamMemberCard;
